import React from "react";
import Header from "../header/Header";
import { Box, Stack } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Sidebar from "../sidebar/Sidebar";
import {
  HEADER_HEIGHT,
  SIDEBAR_MAXWIDTH,
  SIDEBAR_MINWIDTH,
} from "../../../../utils/ui.constants";
import useLocalStorage from "../../../../hooks/useLocalStorage";

function MainLayout({ children }: { children: React.ReactNode }) {
  const theme = useTheme();
  const mdMatch = useMediaQuery(theme.breakpoints.up("md"));
  const [expandSidebar, setExpandSidebar] = useLocalStorage<boolean>(
    "menu_mode",
    true
  );

  const toggleSidebar = () => {
    setExpandSidebar(!expandSidebar);
  };

  return (
    <>
      <Header toggleSideBar={toggleSidebar} />
      {/* Content pc */}
      {mdMatch ? (
        <Stack
          direction="row"
          sx={{
            width: "100%",
            height: `calc(100vh - ${HEADER_HEIGHT})`,
          }}
        >
          <Sidebar expand={expandSidebar} />
          <Box
            sx={{
              p: 2,
              backgroundColor: "background.default",
              width: `calc(100% - ${
                expandSidebar ? SIDEBAR_MAXWIDTH : SIDEBAR_MINWIDTH
              })`,
              height: `calc(100vh - ${HEADER_HEIGHT})`,
              transition: "all linear 0.1s",
              overflow: "auto",
            }}
          >
            {children}
          </Box>
        </Stack>
      ) : (
        <Box
          sx={{
            p: 2,
            backgroundColor: "background.default",
            minHeight: `calc(100vh - ${HEADER_HEIGHT})`,
            height: "auto",
          }}
        >
          {children}
        </Box>
      )}
      {/* Content mobile */}
    </>
  );
}

export default MainLayout;
